import React from "react";
import { withRedux } from "helpers";
import styled, { css } from "react-emotion";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Input,
} from "@material-ui/core";
import { templateTypes, templatePermissionMap } from "constants";
import {
  FlexRow,
  Image,
  // Modal,
  Grid,
  GridItem,
  FlexColumn,
  Button,
  LineButton,
  ModalHeader,
  TextModal,
} from "appStyles";
import Modal from "@material-ui/core/Modal";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import Switch from "@material-ui/core/Switch";
import AlertModal from "../../../Tools/AlertModal";

import { HasPermission } from "components";
import ReactGA from "react-ga";
import { deleteApp } from "../../../../redux/actions/appifyActions";
ReactGA.initialize(
  process.env.NODE_ENV === "prod" ? "UA-108363979-2" : "UA-108363979-3"
);

const item = css`
  position: relative;
  height: 9em;
  min-width: 7em;
  margin: 0.5em;
  text-align: center;
`;
const tableRowClickable = css`
  &:hover {
    background-color: rgba(137, 210, 211, 0.3);
    cursor: pointer;
  }
`;

const container = css`
  box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  position: relative;
  border-radius: 5px;
  margin-bottom: 3em;
  overflow-y: auto;
  height: 98%;
  background-color: white;
  padding: 1em;
`;

const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;
const whiteP = css`
  color: "white";
`;

const P = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: "white";
  display: block;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
`;

const newPageButtonContainer = css`
  position: absolute;
  top: 30%;
  left: 31%;
  background: #707070;
  height: 0.7em;
  width: 2.7em;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const deleteAppButton = css`
  position: absolute;
  right: 0;
  bottom: 0;
  font-size: 0.6em;
`;
// each template card
const typeStrings = {
  store: "Store",
  punchCard: "Punch Card",
  website: "Website",
  deals: "Deals",
  aboutUs: "Contact",
  rewards: "Rewards",
  pictureCatalog: "Image Gallery",
  imageTitleText: "Image Title Text",
  titleText: "Title Text",
};
const TemplateRow = ({
  pageName,
  onClick,
  type,
  deleteTemplate,
  unpublishTemplate,
  deleteRewardTemplate,
  publishTemplate,
  isPublished,
}) => {
  return (
    <TableRow>
      <TableCell
        className={tableRowClickable}
        onClick={onClick}
        style={{
          textAlign: "left",
          borderBottom: "1px solid #DADADA",
          padding: "5px 12px",
          lineHeight: "normal",
        }}
      >
        <P style={{ fontSize: "0.9375rem", lineHeight: "26px" }}>{pageName}</P>
      </TableCell>
      <TableCell
        style={{
          textAlign: "left",
          borderBottom: "1px solid #DADADA",
          padding: "5px 12px",
          lineHeight: "normal",
        }}
      >
        <p
          style={{
            fontWeight: "normal",
            color: "#9E9E9E",
            fontSize: "10px",
          }}
        >
          {typeStrings[type]}
        </p>
      </TableCell>
      <TableCell
        style={{
          textAlign: "left",
          borderBottom: "1px solid #DADADA",
          padding: "5px 12px",
          lineHeight: "normal",
        }}
      >
        {/* {isPublished && !["aboutUs"].includes(type) ? (
          <a
            onClick={unpublishTemplate}
            style={{
              fontSize: "11px",
              backgroundColor: "none",
              width: "50%",

              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Unpublish
          </a>
        ) : null} */}
        {isPublished && !["aboutUs"].includes(type) ? (
          <Switch
            checked={isPublished}
            onChange={unpublishTemplate}
            color="primary"
            name="isPublished"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        ) : null}
        {!isPublished && !["aboutUs"].includes(type) ? (
          <Switch
            checked={isPublished}
            onChange={publishTemplate}
            color="primary"
            name="notPublished"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        ) : null}
      </TableCell>

      <TableCell
        style={{
          textAlign: "right",
          borderBottom: "1px solid #DADADA",
          padding: "5px 12px",
          lineHeight: "normal",
        }}
      >
        {!["aboutUs", "rewards"].includes(type) ? (
          <a
            onClick={deleteTemplate}
            style={{
              fontSize: "11px",
              backgroundColor: "none",
              width: "50%",
              marginLeft: "20px",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Delete
          </a>
        ) : null}
        {type === "rewards" ? (
          <a
            onClick={deleteRewardTemplate}
            style={{
              fontSize: "11px",
              backgroundColor: "none",
              width: "50%",
              marginLeft: "20px",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Delete
          </a>
        ) : null}
      </TableCell>
    </TableRow>
  );
};

class TemplateTable extends React.Component {
  constructor(props) {
    super(props);

    this.deleteApplication = this.deleteApplication.bind(this);
  }

  state = {
    showNewOptions: false,
    showTemplateOptions: false,
    showTemplateDescription: false,
    deleteConfirmationId: null,
    deleteAppConfirmation: false,
    unpublishConfirmationId: false,
    publishConfirmationId: false,
    customWarningMessage: "",
    deleteAppNameInput: "",
  };

  signalDeletionConfirmation = (id) => {
    this.setState({ deleteConfirmationId: id });
  };

  signalUnpublishConfirmation = (id) => {
    this.setState({ unpublishConfirmationId: id });
  };

  signalPublishConfirmation = (id) => {
    this.setState({ publishConfirmationId: id });
  };

  setTemplate = (templateId) => {
    const { activeApp, actions } = this.props;
    actions.setTemplate(activeApp.id, templateId);
  };

  selectNewTemplate = (e) => {
    e.stopPropagation();
    this.setState({ showNewOptions: true });
  };

  addNewTemplate = (templateType) => async () => {
    let {
      activeApp,
      business,
      platformInfo: {
        status: {
          user: { id: userId },
        },
      },
      punchCard,
      actions: {
        createPunchCard,
        addNewTemplate,
        putPunchCard,
        putBusinessApp,
      },
    } = this.props;

    // only create punchcard on punchcard template creation
    // if (templateType === "punchCard") {
    //   await createPunchCard(activeApp.id);
    // }

    addNewTemplate(templateType, { nav: true });
    this.toggleTemplateOptions();
    await putBusinessApp(business, {
      ...activeApp,
      rewardsEnabled: templateType === "rewards" ? 1 : 0,
    });

    const {
      view: {
        navigation: { components },
      },
    } = activeApp;

    const lastestTemplate = components[components.length - 1];

    setTimeout(() => {
      this.setTemplate(lastestTemplate.templateId);
    }, 0);
  };

  uniqueTemplate = (templateType) => {
    return !this.props.activeApp.view.templates
      .map((template) => template.type)
      .includes(templateType);
  };

  toggleTemplateOptions = () => {
    const { showTemplateOptions } = this.state;
    this.setState({ showTemplateOptions: !showTemplateOptions });
  };

  toggleTemplateDescription = (showTemplateDescription) => {
    if (this.state.showTemplateDescription === showTemplateDescription) {
      showTemplateDescription = null;
    }

    this.setState({ showTemplateDescription });
  };

  deleteApplication() {
    const { deleteAppConfirmation, deleteAppNameInput } = this.state;
    const { id, name } = this.props.activeApp;
    // console.log("deleteAppButtonPressed");
    // console.log("app name input:" + deleteAppNameInput);

    if (!deleteAppConfirmation) {
      this.setState({ deleteAppConfirmation: true });
    } else {
      if (name === deleteAppNameInput) {
        this.props.actions.deleteApp(id).then(() => {
          this.props.history.push({
            pathname: "/lobby",
          });
        });
      } else {
        alert("Please enter the correct application name to delete.");
      }
    }
  }

  unpublishTemplate = (templateId, type, pageName) => async () => {
    // console.log("Unpublish button pressed.");
    const { unpublishConfirmationId } = this.state;
    const { activeApp, business, notify } = this.props;
    // console.log("published views before splice: ");
    // console.dir(activeApp.publishedViews);
    // console.log(unpublishConfirmationId);
    if (!unpublishConfirmationId || unpublishConfirmationId !== templateId) {
      this.signalUnpublishConfirmation(templateId);
      return;
    } else {
      // console.log("unpublishing page with template id: " + templateId);
      this.props.actions.unpublishTemplate(templateId);
      // console.log("spliced template from publishedViews");
      // console.dir(activeApp.publishedViews);
      const parsedView = encodeURI(JSON.stringify(activeApp.publishedViews));
      const updatedApp = {
        ...activeApp,
        publishedView: parsedView,
      };
      // console.log("updated app with parsed published view");
      // console.dir(updatedApp);
      // unpublish
      this.props.actions
        .putBusinessApp(business, updatedApp, true, true)
        .then(() => {
          notify("unPublishedTemplate", pageName);
        });
      this.signalUnpublishConfirmation(null);
      this.setState({ customWarningMessage: "" });
    }
  };

  publishTemplate = (templateId, type, pageName, template) => async () => {
    console.log("Publish button pressed.");
    const { publishConfirmationId } = this.state;
    const { activeApp, business, notify } = this.props;
    console.log("published views before splice: ");
    console.dir(activeApp.publishedViews);
    console.log("template before add: ");
    console.dir(template);
    // console.log(unpublishConfirmationId);
    if (!publishConfirmationId || publishConfirmationId !== templateId) {
      this.signalPublishConfirmation(templateId);
      return;
    } else {
      console.log("Publishing page with template id: " + templateId);

      this.props.actions.publishTemplate(templateId, template);
      console.log("spliced template from publishedViews");
      console.dir(activeApp.publishedViews);
      const parsedView = encodeURI(JSON.stringify(activeApp.publishedViews));
      const updatedApp = {
        ...activeApp,
        publishedView: parsedView,
      };
      console.log("updated app with parsed published view");
      console.dir(updatedApp);
      // unpublish
      this.props.actions
        .putBusinessApp(business, updatedApp, true, true)
        .then(() => {
          notify("publishedTemplate", pageName);
        });
      this.signalPublishConfirmation(null);
      this.setState({ customWarningMessage: "" });
    }
  };

  deleteTemplate = (templateId, type) => async () => {
    const {
      activeApp,
      business,
      punchCard,
      actions: { deletePunchCard },
    } = this.props;
    const { deleteConfirmationId } = this.state;

    if (!deleteConfirmationId || deleteConfirmationId !== templateId) {
      // if (type === "punchCard") {
      //   this.setState({
      //     customWarningMessage:
      //       "Please note all users that currently have this punchcard will still be able to finish redeeming it. They will not receive new punchcards until they finish redeeming the existing one.",
      //   });
      // }

      this.signalDeletionConfirmation(templateId);
      return;
    } else {
      // update punchcard to retired
      // if (type === "punchCard") {
      //   await deletePunchCard(punchCard.id);
      // }

      this.props.actions.deleteTemplate(templateId);
      this.props.actions.putBusinessApp(business, activeApp);
      this.signalDeletionConfirmation(null);
      this.setState({ customWarningMessage: "" });
    }
  };

  deleteRewardTemplate = (templateId) => () => {
    let { activeApp, business } = this.props;
    const { deleteConfirmationId } = this.state;

    const updatedApp = {
      ...activeApp,
      cashCreditRewardsEnabled: 0,
      rewardsEnabled: 0,
    };

    if (!deleteConfirmationId) {
      this.signalDeletionConfirmation(templateId);
      return;
    } else if (deleteConfirmationId !== templateId) {
      this.signalDeletionConfirmation(templateId);
    } else {
      this.props.actions.deleteTemplate(templateId);
      this.props.actions.putBusinessApp(business, updatedApp);
      this.signalDeletionConfirmation(null);
    }
  };

  renderDeleteAppConfirmationModal = () => {
    if (!this.state.deleteAppConfirmation) return null;
    return (
      <AlertModal
        title="Delete Application"
        buttons={this.getDeleteAppButtons()}
        render={this.state.deleteAppConfirmation}
      >
        <P style={{ color: "red" }}>
          Are you sure you want to delete your application?
          <br></br>
          <br></br>
          Upon deleting, you will be charged a $199.99 cancellation fee if you
          are still under contract.
          <br></br>
          <br></br>
          You will lose all history and associated data to your app. This can't
          be undone. Please note, you are still legally responsible for
          fulfilling any customer commitments through your app.
        </P>
        <br></br>
        <Input
          fullWidth={true}
          placeholder={"Enter the name of the application to confirm deletion."}
          value={this.state.deleteAppNameInput}
          onChange={(e) =>
            this.setState({ deleteAppNameInput: e.target.value })
          }
        ></Input>
      </AlertModal>
    );
  };
  getDeleteAppButtons = () => {
    return [
      <a
        key="cancelButton"
        variant="contained"
        style={{
          backgroundColor: "white",
          cursor: "pointer",
          color: "#1976d2",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          fontSize: "0.9375rem",
        }}
        onClick={() => this.setState({ deleteAppConfirmation: false })}
      >
        Cancel
      </a>,
      <a
        key="deleteButton"
        variant="contained"
        onClick={this.deleteApplication}
        style={{
          cursor: "pointer",
          backgroundColor: "white",
          color: "red",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          paddingLeft: "10px",
          fontSize: "0.9375rem",
        }}
      >
        Delete
      </a>,
    ];
  };
  getButtons = (type, id) => {
    return [
      <a
        key="cancelButton"
        variant="contained"
        style={{
          backgroundColor: "white",
          cursor: "pointer",
          color: "#1976d2",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          fontSize: "0.9375rem",
        }}
        onClick={() => this.signalDeletionConfirmation(null)}
      >
        Cancel
      </a>,
      !["aboutUs", "rewards"].includes(type) ? (
        <a
          onClick={this.deleteTemplate(id, type)}
          style={{
            cursor: "pointer",
            backgroundColor: "white",
            color: "red",
            fontWeight: "500",
            lineHeight: "1.75",
            borderRadius: "4px",
            letterSpacing: "0.02857em",
            textTransform: "uppercase",
            paddingLeft: "10px",
            fontSize: "0.9375rem",
          }}
        >
          Delete
        </a>
      ) : null,
      ["rewards"].includes(type) ? (
        <Button
          onClick={this.deleteRewardTemplate(id)}
          style={{
            cursor: "pointer",
            backgroundColor: "white",
            color: "red",
            fontWeight: "500",
            lineHeight: "1.75",
            borderRadius: "4px",
            letterSpacing: "0.02857em",
            textTransform: "uppercase",
            paddingLeft: "10px",
            fontSize: "0.9375rem",
          }}
        >
          Delete
        </Button>
      ) : null,
    ];
  };

  getUnpublishButtons = (type, id, pageName) => {
    return [
      <a
        key="cancelButton"
        variant="contained"
        style={{
          backgroundColor: "white",
          cursor: "pointer",
          color: "#1976d2",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          fontSize: "0.9375rem",
        }}
        onClick={() => this.signalUnpublishConfirmation(null)}
      >
        Cancel
      </a>,
      !["aboutUs"].includes(type) ? (
        <a
          onClick={this.unpublishTemplate(id, type, pageName)}
          style={{
            cursor: "pointer",
            backgroundColor: "white",
            color: "red",
            fontWeight: "500",
            lineHeight: "1.75",
            borderRadius: "4px",
            letterSpacing: "0.02857em",
            textTransform: "uppercase",
            paddingLeft: "10px",
            fontSize: "0.9375rem",
          }}
        >
          Unpublish
        </a>
      ) : null,
    ];
  };
  getPublishButtons = (type, id, pageName, template) => {
    return [
      <a
        key="cancelButton"
        variant="contained"
        style={{
          backgroundColor: "white",
          cursor: "pointer",
          color: "#1976d2",
          fontWeight: "500",
          lineHeight: "1.75",
          borderRadius: "4px",
          letterSpacing: "0.02857em",
          textTransform: "uppercase",
          fontSize: "0.9375rem",
        }}
        onClick={() => this.signalPublishConfirmation(null)}
      >
        Cancel
      </a>,
      !["aboutUs"].includes(type) ? (
        <a
          onClick={this.publishTemplate(id, type, pageName, template)}
          style={{
            cursor: "pointer",
            backgroundColor: "white",
            color: "green",
            fontWeight: "500",
            lineHeight: "1.75",
            borderRadius: "4px",
            letterSpacing: "0.02857em",
            textTransform: "uppercase",
            paddingLeft: "10px",
            fontSize: "0.9375rem",
          }}
        >
          Publish
        </a>
      ) : null,
    ];
  };

  renderDeletionConfirmationModal = (currentDeleteTemplate) => {
    if (!currentDeleteTemplate) return null;

    const { id, pageName, type } = currentDeleteTemplate;

    const { customWarningMessage } = this.state;

    return (
      <AlertModal
        title="Confirm Delete Page"
        render={currentDeleteTemplate}
        buttons={this.getButtons(type, id)}
      >
        <P>Are you sure you want to delete "{pageName}"?</P>
      </AlertModal>
    );
  };

  renderUnpublishConfirmationModal = (currentUnpublishTemplate) => {
    if (!currentUnpublishTemplate) return null;

    const { id, pageName, type } = currentUnpublishTemplate;

    const { customWarningMessage } = this.state;

    return (
      <AlertModal
        title="Confirm Unpublish Page"
        render={currentUnpublishTemplate}
        buttons={this.getUnpublishButtons(type, id, pageName)}
      >
        <P>Are you sure you want to unpublish "{pageName}"?</P>
      </AlertModal>
    );
  };

  renderPublishConfirmationModal = (currentPublishTemplate) => {
    if (!currentPublishTemplate) return null;

    const { id, pageName, type } = currentPublishTemplate;

    const { customWarningMessage } = this.state;

    return (
      <AlertModal
        title="Confirm Publish Page"
        render={currentPublishTemplate}
        buttons={this.getPublishButtons(
          type,
          id,
          pageName,
          currentPublishTemplate
        )}
      >
        <P>Are you sure you want to publish "{pageName}"?</P>
      </AlertModal>
    );
  };

  templatesByOrder = () => {
    const {
      activeApp: {
        view: {
          navigation: { components },
          templates,
        },
      },
    } = this.props;
    // console.log("templates: ");
    // console.dir(templates);
    const templateObject = {};
    const order = [...components]
      .sort((a, b) => a.order - b.order)
      .map((n) => n.templateId);
    templates.forEach((t) => (templateObject[t.id] = t));
    return order.map((o) => templateObject[o]);
  };

  isPublished = (templateId) => {
    const { activeApp } = this.props;
    if (activeApp.publishedViews) {
      return activeApp.publishedViews.templates.find(
        (t) => t.id === templateId
      );
    }
    return false;
  };

  render() {
    const { activeApp, showTemplateOrdering } = this.props;
    // console.log("printing publishable: " + activeApp.publishable);
    // console.log("printing current published templates");
    // console.dir(activeApp.publishedViews.templates);
    // console.log("printing UN published view");
    const unpublishedView = JSON.parse(decodeURI(activeApp.unpublishedView));
    // console.dir(unpublishedView.templates);
    const parsedView = encodeURI(JSON.stringify(activeApp.view));

    // console.log(parsedView === activeApp.unpublishedView);
    if (!activeApp) throw new Error("no activeApp, should not be here");
    const { templates } = activeApp.view;
    // console.dir(templates);
    const {
      showTemplateOptions,
      showTemplateDescription,
      deleteConfirmationId,
      unpublishConfirmationId,
      publishConfirmationId,
      deleteAppConfirmation,
    } = this.state;
    const currentDeleteTemplate = templates.find(
      (t) => t.id === deleteConfirmationId
    );
    const currentUnpublishTemplate = templates.find(
      (t) => t.id === unpublishConfirmationId
    );

    const currentPublishTemplate = templates.find(
      (t) => t.id === publishConfirmationId
    );

    return (
      <div
        style={{
          // margin: "0px 40px 0px 0px",
          maxWidth: "735px",
        }}
      >
        <Table
          style={{
            borderCollapse: "collapse",
            margin: "auto",
            marginTop: "20px",
          }}
        >
          <TableHead>
            <TableRow
              style={{
                textAlign: "left",
                borderBottom: "1pt solid black",
                backgroundColor: "#89d2d3",
                color: "white",
              }}
            >
              <TableCell style={{ width: "55%", lineHeight: "0.5em" }}>
                <P
                  style={{
                    padding: "0px 0px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                  className="currentPages"
                >
                  Current Pages
                </P>
              </TableCell>
              <TableCell style={{ lineHeight: "0.5em", padding: "12px" }}>
                <P
                  style={{
                    padding: "0px 0px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Page Type
                </P>
              </TableCell>
              <TableCell style={{ lineHeight: "0.5em", padding: "12px" }}>
                <P
                  style={{
                    padding: "0px 0px",
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  Published?
                </P>
              </TableCell>
              <TableCell style={{ textAlign: "right", lineHeight: "0.5em" }}>
                <a
                  // style={{ margin: "10px 0px", width: "150px" }}
                  style={{
                    width: "max-content",
                    display: "inline-block",
                    fontSize: "12px",
                    textDecoration: "underline",
                    fontWeight: "normal",
                    cursor: "pointer",
                    color: "white",
                  }}
                  onClick={showTemplateOrdering}
                >
                  Reorder Pages
                </a>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.templatesByOrder().map((t) => {
              console.dir(t);
              return (
                <HasPermission
                  key={t.id}
                  permission={templatePermissionMap[t.type]}
                >
                  <TemplateRow
                    // key={t.id}
                    {...t}
                    deleteRewardTemplate={this.deleteRewardTemplate(t.id)}
                    deleteTemplate={this.deleteTemplate(t.id, t.type)}
                    unpublishTemplate={this.unpublishTemplate(
                      t.id,
                      t.type,
                      t.pageName
                    )}
                    publishTemplate={this.publishTemplate(
                      t.id,
                      t.type,
                      t.pageName,
                      t
                    )}
                    isPublished={this.isPublished(t.id)}
                    onClick={() => {
                      try {
                        const currentUser =
                          this.props.platformInfo.status.user.id;
                        const currentApp = this.props.activeApp.id;
                        // console.log(
                        //   `${window.location.pathname}/${t.type}?currenUser=${currentUser}&app=${currentApp}`
                        // );
                        ReactGA.pageview(
                          `${window.location.pathname}/${t.type}?currenUser=${currentUser}&app=${currentApp}`
                        );
                      } catch (e) {
                        console.log(e);
                      }
                      this.setTemplate(t.id);
                    }}
                  />
                </HasPermission>
              );
            })}
          </TableBody>
        </Table>

        {this.renderDeletionConfirmationModal(currentDeleteTemplate)}
        {this.renderUnpublishConfirmationModal(currentUnpublishTemplate)}
        {this.renderPublishConfirmationModal(currentPublishTemplate)}
        {deleteAppConfirmation && this.renderDeleteAppConfirmationModal()}
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            <Button
              style={{
                display: "inline-flex",
                alignItems: "center",
                margin: "0px",
                textAlign: "center",
                boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
              }}
              className={mdcButton}
              onClick={this.toggleTemplateOptions}
            >
              <AddCircleIcon style={{ marginRight: "5px" }}></AddCircleIcon> Add
              New Page
            </Button>
            <a
              onClick={this.deleteApplication}
              style={{
                width: "auto",
                display: "inline-block",
                fontSize: "11px",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Delete App
            </a>
          </div>
        </div>

        <Modal
          open={showTemplateOptions}
          onClose={this.toggleTemplateOptions}
          style={{
            top: "1%",
            width: "97%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div className={container}>
            <div
              style={{
                margin: "1em",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <P
                style={{
                  color: "black",
                  fontSize: "25px",
                  fontWeight: "bold",
                  fontStyle: "normal",
                  fontStretch: "normal",
                  lineHeight: "normal",
                  letterSpacing: "2px",
                  textTransform: "none",
                  width: "auto",
                }}
              >
                Select Page Type
              </P>
              <span
                style={{
                  cursor: "pointer",
                  // marginLeft: "660px",
                  color: "black",
                  // fontSize: "22px",
                }}
                onClick={this.toggleTemplateOptions}
              >
                <CloseIcon fontSize={"large"}></CloseIcon>
              </span>
            </div>
            <Grid columns="4">
              {Object.keys(templateTypes).map((type, idx) => {
                const { title, description, imageUrl, examples } =
                  templateTypes[type];

                // only disable deals and rewards if they aren't already built
                if (type === "deals" && !this.uniqueTemplate("deals")) {
                  return null;
                }

                if (type === "punchCard" && !this.uniqueTemplate("punchCard")) {
                  return null;
                }

                // if (type === "store" && !this.uniqueTemplate("store")) {
                //   return null;
                // }

                if (type === "rewards" && !this.uniqueTemplate("rewards")) {
                  return null;
                }

                return (
                  <HasPermission
                    key={idx}
                    permission={templatePermissionMap[type]}
                  >
                    <GridItem
                      key={idx}
                      margin="1em"
                      width="12em"
                      height="17em"
                      color="white"
                      style={{
                        borderRadius: "5px",
                        flexDirection: "column",
                        display: "flex",
                        justifyContent: "space-evenly",
                        boxShadow: "rgb(120 120 120 / 50%) 3px 3px 13px",
                      }}
                      onClick={this.addNewTemplate(type)}
                    >
                      <P
                        color="black"
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "15px",
                        }}
                        fontSize="0.6em"
                      >
                        {title}
                      </P>
                      <Image
                        style={{ cursor: "pointer" }}
                        src={imageUrl}
                        width="4em"
                      />
                      <P
                        color="black"
                        style={{
                          color: "black",
                          fontSize: "11px",
                          fontWeight: "bold",
                          // marginBottom: "10px",
                          height: "40px",
                        }}
                        fontSize="0.4em"
                      >
                        {description}
                      </P>
                      <P
                        color="black"
                        style={{
                          color: "black",
                          fontSize: "10px",
                        }}
                        fontSize="0.4em"
                      >
                        {examples}
                      </P>
                      {/* <TextModal
                      show={type === showTemplateDescription}
                      width="100%"
                      left="1em"
                    >
                      
                    </TextModal> */}
                      {/* <FlexRow width="70%">
                        <FlexColumn>
                          <P
                            color="black"
                            fontFamily="Arial, Bold"
                            fontSize="0.5em"
                          >
                            {title}
                          </P> */}
                      {/* <Button
                          onClick={this.addNewTemplate(type)}
                          fontSize="0.5em"
                        >
                          Select
                        </Button> */}
                      {/* <LineButton
                          onMouseEnter={() =>
                            this.toggleTemplateDescription(type)
                          }
                          onMouseLeave={() =>
                            this.toggleTemplateDescription(type)
                          }
                          color="black"
                          fontSize="0.5em"
                        >
                          Read More
                        </LineButton> */}
                      {/* </FlexColumn>
                      </FlexRow> */}
                    </GridItem>
                  </HasPermission>
                );
              })}
            </Grid>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRedux(TemplateTable);
